import React from 'react'
import { 
    Container,
    Row,
    Col
} from 'reactstrap'
import { Link } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import Menu from '../../assets/images/vendora-bienvenida-menu.png'
import Perfil from '../../assets/images/vendora-bienvenida-perfil.png'
import iconstep01 from '../../assets/images/welcomeicons-01.png'
import iconstep04 from '../../assets/images/welcomeicons-04.png'
import iconstep05 from '../../assets/images/welcomeicons-05.png'

import '../../assets/css/app.css'

const Academy = () => {
    return (
        <React.Fragment>
            <div className="page-content welcome">
                <Container fluid style={{ maxWidth: !isMobile ? '700px' : '100%' }}>
                    {isMobile && (
                        <Row style={{ marginBottom: '20px' }}>
                            <Col xs={6} sm={6} lg={6}>
                                <img alt="Flecha al Menú" width={100} src={Menu} />
                            </Col>
                            <Col xs={6} sm={6} lg={6} style={{ textAlign: 'right' }}>
                                <img alt="Flecha al Perfil" width={145} src={Perfil} />
                            </Col>
                        </Row>
                    )}
                    <div>
                        <div><h1 className="welcomesectiontitle">Academia <span className="welcomesectionhigh">Vendora</span></h1></div>
                        <br></br>
                        <p className="welcomedescription">En esta seccion encontrarás videos que te ayudaran a convertirte en una emprendedora digital exitosa.</p>
                        <p className="welcomesteps">¡Empieza a generar ingresos con <span className="stepshighlight">Vendora!</span></p>
                        <br /><br />
                        <section className="stepcontainer">
                            <div className="item-imagecontainer"><img className="item-image" alt="Episodio 1"  src={iconstep01} /></div>
                            <div>
                                <h2 className="stepvendora">EPISODIO 1:</h2>
                                <p className="stepvendoratitle">Comparte productos y colecciones por <span style={{fontWeight: 500, color: 'black'}}>Whatsapp</span></p>
                            </div>
                        </section>
                        <div className="video-embed-container">
                            <iframe
                                src='https://www.youtube.com/embed/qVquvH6t9Os?rel=0'
                                title="Ep1Frame"
                                frameBorder='0'
                                allowFullScreen
                            ></iframe>
                        </div>
                        <br></br>
                        <div className="rcornersubtitle"><p>Ve a la sección de <Link to="/discovery">Discovery</Link> y comparte el que más te guste.</p></div>
                        <section className="stepcontainer">
                            <div className="item-imagecontainer"><img className="item-image" alt="Episodio 2"  src={iconstep05} /></div>
                            <div>
                                <h2 className="stepvendora">EPISODIO 2</h2>
                                <p className="stepvendoratitle">Cómo vender desde la plataforma Vendora</p>
                            </div>
                        </section>
                        <div className="video-embed-container">
                            <iframe
                                src='https://www.youtube.com/embed/MyywbCMyt0w?rel=0'
                                title="Ep2Frame"
                                frameBorder='0'
                                allowFullScreen
                            ></iframe>
                        </div>
                        <br></br>
                        <div className="rcornersubtitle"><p>Pregúntale a tus clientes qué les gusta, negocia el precio final y acuerda los detalles de tu pago.</p></div>
                        <section className="stepcontainer">
                            <div className="item-imagecontainer"><img className="item-image" alt="Episodio 3"  src={iconstep04} /></div>
                            <div>
                                <h2 className="stepvendora">EPISODIO 3</h2>
                                <p className="stepvendoratitle">Coloca <span>un pedido en Vendora</span></p>
                            </div>
                        </section>
                        <div className="video-embed-container">
                            <iframe
                                src='https://www.youtube.com/embed/_2DgpLIMq_Q?rel=0'
                                title="Ep3Frame"
                                frameBorder='0'
                                allowFullScreen
                            ></iframe>
                        </div>
                        <br></br>
                        <div className="rcornersubtitle"><p>Agrega los productos que vendiste al carrito. Recuerda que puedes pagar en Oxxo, depósito o transferencia, y en línea.</p></div>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Academy
